import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, map, tap } from 'rxjs';
import { BYPASS_LOG } from 'src/app/pages/app/interceptor/interceptor.service';
import { environment } from 'src/environments/environment';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';

@Injectable({
	providedIn: 'root',
})
export class ParticipateCompanyService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadcompanyinit(jobFairId: any) {
		return this.ngrxService.loadInitAPI('company', 'list', jobFairId);
	}

	loadcompanyapi(jobFairId: number) {
		return this.getCompany(jobFairId).pipe(
			map((data: any) => {
				let jobFair = { jobFairId, data: data.data };
				return this.ngrxService.loadInitData(
					'company',
					'list',
					jobFairId,
					data.data,
				);
			}),
		);
	}

	fetchcompanydata(jobFairId: any) {
		return this.ngrxService.loadData('company', 'list', jobFairId);
	}

	getCompany(jobfairId: number) {
		return this.http.get(
			environment.url.company + `/jobfair/${jobfairId}/company`,
		);
	}

	addCompany(jobfairId: number, companyId: number[]) {
		return forkJoin(
			companyId.map(id =>
				this.http
					.post(
						environment.url.company + `/jobfair/${jobfairId}/company/${id}`,
						{},
						{ context: new HttpContext().set(BYPASS_LOG, true) },
					)
					.pipe(
						tap(data => {
							this.loadcompanyapi(jobfairId).subscribe();
						}),
					),
			),
		);
	}

	removeCompany(
		jobfairId: number,
		companyId: number,
		jobFairCompanyId: number,
	) {
		// let companyList = [];
		// this.fetchcompanydata(jobfairId).subscribe(({ data }: any) => {
		// 	if (data) {
		// 		companyList = data.filter((data: any) => {
		// 			return data.id !== companyId;
		// 		});
		// 	} else {
		// 		companyList = [];
		// 	}
		// 	console.log('check remove')
		// 	this.ngrxService.loadInitData('company', 'list', jobfairId, companyList);
		// });
		console.log('check remove');
		return this.http
			.delete(
				environment.url.company +
					`/jobfair/${jobfairId}/company/${companyId}/id/${jobFairCompanyId}`,
			)
			.pipe(
				tap(data => {
					this.loadcompanyapi(jobfairId).subscribe();
				}),
			);
	}

	approveState(jobfairId: any, id: any) {
		return this.http
			.put(
				environment.url.company + `/jobfair/company/status/approved/${id}`,
				{},
			)
			.pipe(
				tap(data => {
					this.loadcompanyapi(jobfairId).subscribe();
				}),
			);
	}
	rejectState(jobfairId: any, id: any) {
		return this.http
			.put(
				environment.url.company + `/jobfair/company/status/rejected/${id}`,
				{},
			)
			.pipe(
				tap(data => {
					this.loadcompanyapi(jobfairId).subscribe();
				}),
			);
	}
}
